module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_3.b00a66c1.jpg";